import React, { useState, useEffect } from 'react';
import './styles.scss';

function LoadingOverlay({ isLoading }) {

    useEffect(() => {
    }, [isLoading]);

   
    return (
        <div className={`loading-overlay ${isLoading ? 'visible' : ''}`}>
            <div className="loading-overlay-content">
                <span>加载中...</span>
            </div>
        </div>
    );
};

export default LoadingOverlay ;